import React from 'react'
import { useT } from '@transifex/react'
import { VendImage } from '@vend/react-utilities'
import { useAppDispatch, useAppSelector } from '../../../state/hooks'
import { selectActiveRegisterId } from '../../../state/slices/posState/posStateSlice'
import { useFetchPairing } from '../lspay-payment-modal/hooks/useFetchPairing'
import { setAttemptPayment } from '../../../state/slices/terminalStatus/terminalStatusSlice'
import { useTerminalStatusFromRedux } from './useTerminalStatusFromRedux'
import { getWarningConfig } from './terminal-status-event-handler'

export const TerminalStatusContent: React.FC = () => {
  const t = useT()
  const dispatch = useAppDispatch()
  const registerId = useAppSelector(selectActiveRegisterId)
  const { pairing } = useFetchPairing(registerId ?? '')
  const { warningType } = useTerminalStatusFromRedux()

  if (!warningType || !pairing) {
    return null
  }
  const warning = getWarningConfig(t, pairing.deviceLabel)[warningType]

  const hasBullets =
    warning.modalContent.bullets && warning.modalContent.bullets.length > 0

  return (
    <section className="terminal-status-modal">
      <div className="main">
        <div className="warning-icon">
          <VendImage
            alt="warning icon"
            relativeImagePath={warning.modalContent.imagePath}
            relativeDarkImagePath={warning.modalContent.darkImagePath}
          />
        </div>

        <div className="warning-content">
          <div className="title">{warning.title}</div>
          <div className="body">{warning.modalContent.message}</div>

          {hasBullets && (
            <ul className="list">
              {warning.modalContent.bullets?.map(b => (
                <li key={b} className="list-item">
                  {b}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="footer">
        <button
          type="button"
          className="action"
          onClick={() => dispatch(setAttemptPayment(true))}
        >
          {t('Attempt anyways')}
        </button>
      </div>
    </section>
  )
}
